import { render, staticRenderFns } from "./GalleryCarousel.vue?vue&type=template&id=366378b6&scoped=true&"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js&"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCarousel.vue?vue&type=style&index=0&id=366378b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366378b6",
  null
  
)

export default component.exports